import {
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalFooterPosition,
   ModalLink,
   ModalWidth,
   SaveFileIcon,
} from '@dreryk/react-components';

import { magistralDrugTranslationKeys, visitTranslationKeys } from '../../../../translations';
import { MagistralDrugTemplateModalOpener } from '../../prescriptionTemplates/magistralDrug/modal/MagistralDrugTemplateModal.opener';

import { MagistralDrugCreateForm } from './MagistralDrugCreateForm';
import { MagistralDrugCreateFormBean, OnMagistralDrugCreated } from './MagistralDrugCreateForm.types';
import { mapMagistralDrugCreateFormBeanToMagistralDrugTemplate } from './MagistralDrugCreateForm.utils';
import { MagistralDrugCreateAction } from './MagistralDrugCreateAction';

type MagistralDrugCreateModalProps = {
   readonly onMagistralDrugCreated: OnMagistralDrugCreated;
   readonly onClose: VoidFunction;
};

export const MagistralDrugCreateModal = (props: MagistralDrugCreateModalProps): JSX.Element => {
   return (
      <Modal testId={'magistralDrugCreateModal'} width={ModalWidth.WIDE} title={magistralDrugTranslationKeys.tabName}>
         <MagistralDrugCreateForm>
            {({ handleSubmit, reset, formState, getValues, onInsert, onUse }) => (
               <>
                  <MagistralDrugTemplateModalOpener
                     onInsert={onInsert}
                     onUse={onUse}
                     shouldConfirmUse={formState.isDirty}
                     defaultTemplate={() =>
                        mapMagistralDrugCreateFormBeanToMagistralDrugTemplate(
                           getValues() as MagistralDrugCreateFormBean
                        )
                     }
                  >
                     {({ openModal }) => (
                        <ModalLink
                           testId={'saveAsTemplate'}
                           label={visitTranslationKeys.controlsBar.saveAsTemplate}
                           onClick={openModal}
                           icon={<SaveFileIcon />}
                           position={ModalFooterPosition.SUPPLEMENTARY}
                        />
                     )}
                  </MagistralDrugTemplateModalOpener>
                  <ModalCancelButton
                     label={magistralDrugTranslationKeys.resetForm}
                     onClick={reset}
                     shouldConfirmExit={{
                        enabled: true,
                        title: magistralDrugTranslationKeys.resetFormModal.title,
                        content: magistralDrugTranslationKeys.resetFormModal.content,
                        confirmationButtonLabel: magistralDrugTranslationKeys.resetFormModal.confirmationButtonLabel,
                     }}
                  />
                  <MagistralDrugCreateAction
                     handleSubmit={handleSubmit}
                     reset={reset}
                     onMagistralDrugCreated={props.onMagistralDrugCreated}
                     onClose={props.onClose}
                  />
               </>
            )}
         </MagistralDrugCreateForm>
         <ModalCloseButton onClick={props.onClose} />
      </Modal>
   );
};
